import { render, staticRenderFns } from "./test-email-sender.vue?vue&type=template&id=1515f681"
import script from "./test-email-sender.vue?vue&type=script&lang=js"
export * from "./test-email-sender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1515f681')) {
      api.createRecord('1515f681', component.options)
    } else {
      api.reload('1515f681', component.options)
    }
    module.hot.accept("./test-email-sender.vue?vue&type=template&id=1515f681", function () {
      api.rerender('1515f681', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/test-email-sender.vue"
export default component.exports